import ModelService from '../base/ModelService';

class ImageUploader extends ModelService {
  constructor() {
    super('uploader/images');
  }
}

export default new ImageUploader();
